import { ImportExportLevel } from './public_model';

export type ImportCsvJson = {
    options: CsvJsonOption[];
    version: string;
};

export type CsvJsonOption = {
    isDefault: TrueFalseValue;
    isEnabled: TrueFalseValue;
    optionName: string;
    rowNumber: number;
    // path: [] //Sprawdzamy czy path jest taki sam jak ścieżka dojścia do wartości
    id?: string;
    levelDescription?: string;
    levelName?: string;
    options?: CsvJsonOption[];
};
export const TruthyValueArray = ['YES', 'yes', 'Yes', 'y', 'Y', '1', 1, 'True', 'TRUE', 'T', 't', 'true', true] as const;
type TruthyValue = (typeof TruthyValueArray)[number];

export const FalsyValueArray = ['NO', 'no', 'No', 'n', 'N', '0', 0, 'False', 'FALSE', 'F', 'f', 'false', false] as const;
type FalsyValue = (typeof FalsyValueArray)[number];

export type TrueFalseValue = TruthyValue | FalsyValue;
export const TrueFalseArray = [...TruthyValueArray, ...FalsyValueArray];
export const HEADER_1_NAME = 'Level 1';
export const HEADER_ID_OPTION_NAME = 'ID option';
export const VALID_HEADERS_NAMES = [
    HEADER_1_NAME,
    'Level 2',
    'Level 3',
    'Level 4',
    'Level 5',
    'Level 6',
    'Level 7',
    'Default',
    'Enabled',
    HEADER_ID_OPTION_NAME,
    'Level description',
    'Level name',
];
export type ParsedCsv = {
    headers: string[];
    options: CsvJsonOption[];
    rows: CsvOptionRow[];
};

export type CsvOptionRow = {
    'Level 1': string;
    Default?: string;
    Enabled?: string;
    'ID option'?: string;
    'Level 2'?: string;
    'Level 3'?: string;
    'Level 4'?: string;
    'Level 5'?: string;
    'Level 6'?: string;
    'Level 7'?: string;
    'Level description'?: string;
    'Level name'?: string;
};

export type ValidationPathError = {
    message: string;
    path: string;
    invalidValue?: string;
};

export type ValidationResult = {
    errors: ValidationPathError[];
    success: boolean;
    statistics?: {
        toAdd: number;
        toUpdate: number;
    };
};

export type ImportResult = {
    data: ImportExportLevel;
} & ValidationResult;
